import apiClient, { getBenefitsDictionary } from "../../../../../../services/apiClient";

export const statisticsActions = {
  // Получение списка пільг
  getBenefits: async () => {
    return await getBenefitsDictionary();
  },

  // Получение статистики по районам
  getQueueDistrict: async (studyYear, params = '') => {
    const url = params ? `queue_distr/${studyYear}?${params}` : `queue_distr/${studyYear}`;
    return await apiClient.get(url);
  },

  // Получение общей статистики
  getQueueAll: async (studyYear, params = '') => {
    const url = params ? `queue_new_all/${studyYear}?${params}` : `queue_new_all/${studyYear}`;
    return await apiClient.get(url);
  }
};